// import * as React from 'react';
// import { IBannerWpProps } from '../BannerWp/IBannerWpProps';

// export interface IBdefaultState{
//   title:string;
// }
// export default class BannerDefault extends React.Component<IBannerWpProps, IBdefaultState> {

//   constructor(props){
//     super(props);
//   }

//   public render() {
//     return (<p></p>);
//   }
// }

